import { render } from "./WarningModal.vue?vue&type=template&id=64c0dfec"
import script from "./WarningModal.vue?vue&type=script&lang=js"
export * from "./WarningModal.vue?vue&type=script&lang=js"

import "./WarningModal.vue?vue&type=style&index=0&id=64c0dfec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__